import { Language } from 'store/slices/language-slice';

interface FundsMessages {
  seo: {
    title: string;
    description: string;
    keywords: string;
  };
  common: {
    currencySymbolZAR: string;
    currencySymbolGBP: string;
    reference: string;
    amount: string;
  };
  warningMessages: {
    fileNameTooLong: string;
  };
  summary: {
    summaryMainProductCashBalanceTitle: string;
    summaryMainProductCashBalanceRightTitle: string;
    summaryMainProductIntroducing: string;
    summaryMainProductAbout: string;
    summaryMainProductInvest: string;
    summaryMainProductBenefits: string;
  };
  depositTypes: {
    backText: string;
    typesHeading: string;
    typesSubHeading: string;
    bankTransfer: string;
    bankTransferSubHeading: (productCode: string) => string;
    linkedAccount: string;
    linkedAccountSubHeading: string;
    ozow: string;
    ozowSubText: string;
    card: string;
    cardSubText: string;
    cryptocurrency: string;
    cryptocurrencySubText: string;
    depositFiat: string;
    disabledDepositFiat: string;
    depositCrypto: string;
    depositFiatSubHeading: (fiatCurrency: string) => string;
    depositCryptoSubHeading: string;
    modalAlt: string;
    modalHeadingEft: string;
    modalContentEft: string;
    modalContentEftHeader: string;
    modalContentEftAmount: string;
    modalContentEftPaymentRef: string;
    modalContentEftAccountType: string;
    modalContentEftBank: string;
    modalContentEftIBAN: string;
    modalContentEftRecipient: string;
    modalContentEftAccountNumber: string;
    modalContentEftBranchNumber: string;
    modalContentEftQuotedFee: string;
    modalContentEftSortCode: string;
    modalContentEftSwiftCode: string;
    modalProfileEft: string;
    modalCancelEft: string;
    modalZARSymbol: string;
    modalGBPSymbol: string;
    modalContentFooterLimitZAR: string;
    modalContentFooterLimitGBP: Function;
    modalContentFooterSupport: (supportEmail: string | undefined) => string;
    modalContentFooterLimit: Function;
  };
  bankTransfer: {
    modalBankTransferHeader: string;
    modalBankTransferZARContent: string;
    modalBankTransferGBPContent: string;
    modalAcknowledge: string;
    understand: string;
    backText: string;
    depositText: string;
    specifyAmount: string;
    extraText: string;
    feeTextRand: string;
    feeTextGBPSection1: string;
    feeTextGBPClickText: string;
    feeTextGBPSection2: string;
    minText: string;
    minTextTooltipSection1: string;
    minTextTooltipSection2: string;
    minTextTooltipSection3: string;
    maxText: string;
    maxTextTooltip: string;
    maxTextZarFee: string;
    maxTextGbpFee: string;
    feeGBPModalHeader: string;
    feeGBPModalContent: string;
    continue: string;
    close: string;
    blockedNavigation: string;
    linkedAccountModalHeader: string;
    confirmDeposit: string;
    feeText: string;
    recieveText: string;
    buttonModalCopy: string;
    amountText: string;
    minimumAmount: string;
    maximumAmount: string;
    depositFee: string;
    linkedAccountText: Function;
    errorModalHeading: string;
    errorModalCopy: Function;
    errorModalButtonCopy: string;
    errorModalcancelButtonCopy: string;
    depositComplete: string;
    depositCompleteCopy: string;
    pendingDepositHeading: string;
    pendingDepositSubheading: string;
    pendingDepositTransferAmount: string;
    pendingDepositFee: string;
    pendingDepositReceived: string;
    pendingDepositBank: string;
    pendingDepositAccount: string;
    pendingDepositReference: string;
    transferText: string;
    recieveText2: string;
    referenceText: string;
    viewPortfolioText: string;
    accountText: string;
    accountNameText: string;
    bankCopy: string;
  };
  bankTransferPending: {
    backText: string;
    depositText: string;
    depositTextRands: string;
    depositTextGBP: string;
    pendingSubHeader: string;
    pendingSubHeaderGBP: string;
    currencyRand: string;
    currencyNameRand: string;
    currencyGBP: string;
    currencyNameGBP: string;
    currencySymbolRand: string;
    currencySymbolGBP: string;
    amount: string;
    paymentRef: string;
    recipient: string;
    accountType: string;
    bank: string;
    sortCode: string;
    accountNumber: string;
    branchNumber: string;
    swiftCode: string;
    IBAN: string;
    quotedFee: string;
    proofOfPaymentByCurrency: (
      fiatCurrency: string,
      supportEmail: string | undefined,
    ) => string;
    popSupport: string;
    popUploadSuccess: string;
    popUploadError: string;
    paymentMade: string;
    paymentLater: string;
    cancelPayment: string;
    cancelPaymentError: string;
    fundsReceivedTitle: string;
    fundsReceivedSubHeader: string;
    amountReceived: string;
    fundsReceivedInfo: (supportEmail: string | undefined) => string;
    backToPortfolio: string;
    copyImg: string;
    copied: string;
    companyAddress: string;
    bankAddress: string;
  };
  bankTransferComplete: {
    imgAlt: string;
    depositThanks: string;
    whatHappensNext: string;
    nextStepList: string;
    exploreProducts: string;
    setRecurringDeposit: string;
  };
  cryptoDeposit: {
    backText: string;
    typesHeading: string;
    typesSubHeading: string;
    cryptoIconAlt: string;
    price: string;
    modalAlt: string;
    modalHeadingCrypto: string;
    modalContentCrypto: string;
    modalProfileCrypto: string;
    modalCancelCrypto: string;
    assetNetworkHeading: string;
    noResultsFound: string;
    searchAssets: string;
  };
  cryptoDepositDetails: {
    backText: string;
    modalImgAlt: string;
    modalHeading: string;
    modalContent: (supportEmail: string | undefined) => string;
    modalAcknowledge: string;
    modalCancel: string;
    typesHeading: string;
    typesSubHeadingSection1: string;
    typesSubHeadingSection2: string;
    copyText: string;
    copiedText: string;
    cryptoDisclaimer: string;
    cryptoMin: string;
    cryptoMinTooltip: string;
    cryptoDepositFees: string;
    cryptoDepositDepositMade: string;
    bitcoinSymbol: string;
    modalAlt: string;
    errorModalContent: string;
    modalPortfolio: string;
    depositAddressToSendTo: string;
    walletAddress: string;
    tag: string;
    minimumText: string;
    feeText: string;
    copyButtonText: string;
  };
  cryptoDepositDisclaimer: {
    disclaimerHeading: string;
    disclaimerSubHeading: string;
    networkHeading: string;
    buttonCopy: string;
  };
  cryptoDepositFungibilityModal: {
    modalHeading: string;
    modalBodyP1: Function;
    modalBodyP2: string;
    submitText: string;
    dontShowAgain: string;
  };
  cryptoDepositComplete: {
    imgAlt: string;
    header: string;
    subText: string;
    exploreProducts: string;
  };
  fundsWithdraw: {
    backText: string;
    withdrawHeading: string;
    withdrawSubHeading: string;
    withdrawDetailsHeading: string;
    wallet: string;
    balance: string;
    accountCooldownTitle: string;
    accountCooldownContent: string[];
    imgAltNoFunds: string;
    imgAltPendingWithdraw: string;
    modalHeading: {
      withdrawPending: string;
      noWithdraw: string;
    };
    modalContent: {
      withdrawPending: Function;
      noWithdraw: string;
    };
    modalFooter: {
      cancelWithdrawalButton: string;
      closeButton: string;
      goToProfile: string;
    };
    alt: string;
    btc: string;
    reactOutAlt: string;
    reactOutHeading: string;
    reactOutContent: (supportEmail: string | undefined) => string;
    reactOutPortfolio: string;
    reserved: string;
    reservedDescription: string;
  };
  fundsWithdrawFiat: {
    backText: string;
    withdrawHeading: string;
    withdrawSubHeading: string;
    currencySymbolRand: string;
    currencySymbolGBP: string;
    leftText: string;
    leftTooltip: string;
    rightText: string;
    rightTooltipSection1: string;
    rightTooltipSection2: string;
    extraText: string;
    next: string;
    modalBankAccountHeader: string;
    modalBankAccountButton: string;
    imgAlt: string;
    blockedNavigation: string;
  };
  fundsBankDetails: {
    backText: string;
    detailsHeading: string;
    detailsHeadingSubHeading: string;
    bankCountry: string;
    bankAccountNumber: string;
    bankName: string;
    bankAccountType: string;
    bankBranch: string;
    bankSortCode: string;
    bankIBAN: string;
    bankIBANOrSwift: string;
    bankExtraText: string;
    bankBlockParagraph: string;
  };
  fundsWithdrawFiatReview: {
    backText: string;
    withdrawHeading: string;
    reviewSubHeading: string;
    pendingRecipient: string;
    pendingAccountNumber: string;
    pendingType: string;
    pendingBank: string;
    pendingBranchCode: string;
    pendingSortCode: string;
    pendingIBAN: string;
    pendingIBANOrSwift: string;
    pendingEditBankDetails: string;
    pendingEditBankDetailsAlt: string;
    pendingSeeMore: string;
    pendingSeeLess: string;
    pendingExtraTextShort: string;
    pendingExtraTextSection1ZAR: string;
    pendingExtraTextSection1INT: Function;
    pendingFeeText: string;
    pendingExtraTextSection2: string;
    pendingUnderstand: string;
    pendingNext: string;
    modalPortfolioCrypto: string;
    modalAlt: string;
    pendingHeader: string;
    pending1: string;
    pending2: string;
  };
  fundsFiatInProgress: {
    backText: string;
    withdrawHeading: string;
    inProgressSubHeading: string;
    amount: string;
    reference: string;
    date: string;
    timeZAR: string;
    timeGBP: string;
    recipient: string;
    accountNumber: string;
    type: string;
    bank: string;
    branchCode: string;
    sortCode: string;
    IBAN: string;
    withdrawalAmount: string;
    fee: string;
    amountReceived: string;
    portFolio: string;
    alt: string;
  };
  fundsCryptoDetails: {
    backText: string;
    heading: string;
    subHeadingSection: string;
    add: string;
    edit1: string;
    edit2: string;
    extraText1: string;
    extraTextUsdt: string;
    extraText2: string;
    acknowledge: string;
    continue: string;
    noAddress: string;
    noRef: string;
  };
  fundsCryptoAmount: {
    backText: string;
    heading: string;
    subHeadingSection1: string;
    subHeadingSection2: string;
    alt: string;
    selectAmount: string;
    fee: string;
    minText: string;
    leftTooltip1: string;
    leftTooltip2: string;
    leftFeeTooltip: (productName: string, feeAsCurrency: string) => string;
    rightFeeTooltip: (feeAsCurrency: string) => string;
    rightTooltip: string;
    withDrawTo1: string;
    withDrawTo2: string;
    extraText1: string;
    continue: string;
    modalPortfolioCrypto: string;
    modalAlt: string;
    pendingHeader: string;
    pending1: string;
    pending2: string;
    btc: string;
    blockedNavigation: string;
  };
  fundsCryptoComplete: {
    imgAlt: string;
    heading: string;
    subHeading: string;
    button: string;
  };
  fundsPending: {
    error: string;
    modalAlt: string;
    modalPortfolioCrypto: string;
  };
  transactions: {
    goToTransactions: string;
  };
  linkedAccounts: {
    linkedAccountsHeading: string;
    linkedAccountsSubHeading: string;
    linkedAccountText: string;
    maximumAmount: string;
    feeText: string;
    buttonCopy: string;
    allocationTime: string;
    secureText: string;
    maximumAmountValue: string;
    feeAmount: string;
    allocationTimeResult: string;
    availableText: string;
    customerBank: string;
    accountType: string;
    accountNumber: string;
    availableBalance: string;
    manageAccountSubHeading: string;
    renameButtonCopy: string;
    unlinkButtonCopy: string;
    accountDetails: string;
    unlinkAccountModalCopy: string;
    unlinkAccountModalRemoveText: Function;
    unlinkAccountModalButtonCancelText: string;
    unlinkAccountModalButtonUnlinkText: string;
  };
  depositAccountName: {
    subHeading: string;
    chooseNameText: string;
    accountName: string;
    buttonCopy: string;
    accountNameModalHeading: string;
    accountNameModalText: string;
    accountNameModalButtonCopy: string;
    renameAccountLater: string;
    renameAccountLaterText: string;
    defaultAccountNameText: Function;
    renameAccountLaterButtonCopy: string;
    unlinkAccountModalHeading: string;
    unlinkAccountModalText: Function;
    renameLinkedAccountSuccessfulHeading: string;
  };
}

type Message = {
  [key in Language]: FundsMessages;
};

const messages: Message = {
  en: {
    seo: {
      title: 'Altify - Funds',
      description:
        'Effortlessly invest in crypto with one of our Bundles. Investing has never been this easy.',
      keywords:
        'investing, investment platform, cryptocrurency, top 10 cryptocurrency, top cryptocurrency, top performing crypto, diversification, diversified investing',
    },
    common: {
      currencySymbolZAR: 'R',
      currencySymbolGBP: '£',
      reference: 'Reference',
      amount: 'Amount',
    },
    warningMessages: {
      fileNameTooLong:
        'Your file name is too long, please rename the file to no more than 50 characters and try again.',
    },
    summary: {
      summaryMainProductCashBalanceTitle: 'Fiat cash balances',
      summaryMainProductCashBalanceRightTitle: 'Available',
      summaryMainProductIntroducing: 'Introducing',
      summaryMainProductAbout: 'About',
      summaryMainProductInvest: 'Invest',
      summaryMainProductBenefits: 'Benefits',
    },
    depositTypes: {
      backText: '← Back',
      typesHeading: 'Deposit Funds',
      typesSubHeading: 'Please select a deposit method',
      bankTransfer: 'Bank Transfer',
      bankTransferSubHeading: (productCode: string) =>
        'Reflects within 3 days, no fee',
      linkedAccount: 'Linked bank account',
      linkedAccountSubHeading:
        'Link your bank account to make secure, instant deposits',
      ozow: 'Instant EFT',
      ozowSubText: 'Reflects immediately, 1.50% fee',
      card: 'Credit and debit card',
      cardSubText: 'Reflects immediately, 1.50% fee',
      cryptocurrency: 'Cryptocurrency',
      cryptocurrencySubText: 'Network fees and speeds apply',
      modalAlt: 'pending-deposit',
      modalHeadingEft: 'Pending deposit',
      modalContentEft:
        'You already have a deposit pending, if you would like to change your deposit please select cancel and create a new one.',
      modalContentEftHeader: 'Deposit details:',
      modalContentEftAmount: 'Amount',
      modalContentEftPaymentRef: 'Payment reference',
      modalContentEftAccountType: 'Account Type',
      modalContentEftIBAN: 'IBAN',
      modalContentEftBank: 'Bank',
      modalContentEftRecipient: 'Recipient',
      modalContentEftAccountNumber: 'Account Number',
      modalContentEftBranchNumber: 'Branch Code',
      modalContentEftQuotedFee: 'Processing Fee',
      modalContentEftSortCode: 'Sort Code',
      modalContentEftSwiftCode: 'SWIFT / BIC',
      modalProfileEft: 'Back to profile',
      modalCancelEft: 'Cancel deposit',
      depositFiat: 'Bank Deposit',
      depositCrypto: 'Crypto Deposit',
      disabledDepositFiat:
        'Depositing from your bank account is currently not available',
      depositFiatSubHeading: (fiatCurrency: string) =>
        `Deposit ${fiatCurrency} from your bank account`,
      depositCryptoSubHeading: 'Deposit supported crypto from another wallet',
      modalZARSymbol: 'R',
      modalGBPSymbol: '£',
      modalContentFooterLimitZAR:
        'Deposits greater than R100 000.00 may require additional processing time.',
      modalContentFooterLimitGBP: (currencySymbol: string) =>
        `Deposits greater than ${currencySymbol}5 000.00 may require additional processing time.`,
      modalContentFooterLimit: (formattedCurrency: string) =>
        `Deposits greater than ${formattedCurrency} may require additional processing time.`,
      modalContentFooterSupport: (supportEmail: string | undefined) =>
        `Reach out to our friendly support team at ${supportEmail} if your deposit has not been allocated within 24 hours.`,
    },
    bankTransfer: {
      modalBankTransferHeader: 'How our bank deposits work',
      modalBankTransferZARContent: `
                <ol class="custom-list">
                    <li class="custom-li"><div><span><strong>Enter the amount</strong></span>&nbsp;that you'd like to deposit.</div></li>
                    <li class="custom-li"><div><span><strong>Add Altify as a beneficiary</strong></span>&nbsp;on your banking app.</div></li>
                    <li class="custom-li"><div><span><strong>Use your unique payment reference</strong></span>&nbsp;and send your deposit to Altify.</div></li>
                </ol>
            `,
      modalBankTransferGBPContent: `
                <ol class="custom-list">
                    <li class="custom-li"><div><span><strong>Enter the amount</strong></span>&nbsp;that you'd like to deposit.</div></li>
                    <li class="custom-li"><div><span><strong>Add Altify as a beneficiary</strong></span>&nbsp;on your banking app.</div></li>
                    <li class="custom-li"><div><span><strong>Use your unique payment reference</strong></span>&nbsp;and send your deposit to Altify.</div></li>
                </ol>
            `,
      modalAcknowledge: "Don't show me this again.",
      understand: 'I understand',
      backText: '← Back',
      depositText: 'Deposit',
      specifyAmount: 'Please specify the amount',
      extraText: `
                                You may <span style="font-weight:600" >only send funds from an account in your name</span>.
                                <br />
                                You <u><span style="font-weight:600" >may not</span></u> send funds to your account from a family member, a friend or a business.
                                <br />
                                <br />
                                We only accept bank deposits. 
                                <br />
                                <span style="font-weight:600">Cash deposits cannot be processed</span>.
								<br />
								Create an <span style="font-weight:600">instant deposit</span> for a quicker deposit allocation. 
                            `,
      feeTextRand: 'Deposits are processed as soon as they are received.',
      feeTextGBPSection1: 'Our',
      feeTextGBPClickText: 'fees',
      feeTextGBPSection2:
        'are different for Faster Payment Service (FPS) and CHAPS or SWIFT payments.',
      minText: 'Minimum',
      minTextTooltipSection1: `
                The minimum deposit amount is
            `,
      minTextTooltipSection2: `
               Any amount deposited below this will be returned with a
            `,
      minTextTooltipSection3: `
               processing charge.
            `,
      maxText: 'Maximum',
      maxTextTooltip: `
                This is the maximum amount you can deposit for this transaction.
                <br />
                <br />
                This amount is calculated using your account limits.
            `,
      maxTextZarFee: 'R50',
      maxTextGbpFee: '8.00',
      feeGBPModalHeader: 'GBP deposit fees',
      feeGBPModalContent: `
                We don't charge deposit fees on Faster Payments.
                <br />
                <br />
                BACS, CHAPS and SWIFT payments incur a £ 30.00 bank processing fee.
            `,
      continue: 'Continue',
      close: 'Close',
      blockedNavigation:
        'Your deposit is currently being created, please wait for it to complete.',
      linkedAccountModalHeader: 'Change bank account',
      confirmDeposit: 'Confirm deposit',
      feeText: 'Fee',
      recieveText: 'You’ll receive',
      buttonModalCopy: 'Continue',
      amountText: 'Amount',
      minimumAmount: 'Minimum amount',
      maximumAmount: 'Maximum amount',
      depositFee: '1.00%',
      linkedAccountText: (accountName: string) => `From ${accountName}`,
      errorModalHeading: 'How to make a large deposit',
      errorModalCopy: (
        maximumString: string,
      ) => `You can deposit a maximum of ${maximumString}
                from a linked account. 
                <br />
                <br />
                For larger deposits, create a bank transfer from your banking app. 
                <br />
                <br />
                Create an instant transfer when making your payment for a faster allocation. `,
      errorModalButtonCopy: 'Use bank transfer ->',
      errorModalcancelButtonCopy: 'Cancel',
      depositComplete: 'Deposit complete',
      depositCompleteCopy: 'Your deposit was successful!',
      pendingDepositHeading: 'Your deposit is pending',
      pendingDepositSubheading:
        'Complete the authentication required with your bank to process this deposit',
      pendingDepositTransferAmount: 'Transfer amount',
      pendingDepositFee: 'Stitch fee',
      pendingDepositReceived: 'Your deposit',
      pendingDepositBank: 'Bank',
      pendingDepositAccount: 'Account',
      pendingDepositReference: 'Reference',
      transferText: "You've transferred",
      recieveText2: "You've received",
      referenceText: 'Reference',
      viewPortfolioText: 'View portfolio ->',
      accountText: 'Account number',
      accountNameText: 'Account name',
      bankCopy: 'Bank',
    },
    bankTransferPending: {
      backText: '← Back',
      depositText: 'Deposit',
      depositTextRands: 'Rands',
      depositTextGBP: 'GBP',
      pendingSubHeader: `
                To fund your account please make a transfer using the details shown below.
                <br />
                These details have been emailed to you.
            `,
      pendingSubHeaderGBP: `
                While we set up our UK bank account please send 
                <br />
                your GBP to our South African bank account. 
                <br />
                <br />
                Our bank details are shown below and have been
                <br />
                emailed to you.
            `,
      currencyRand: 'Rand',
      currencyNameRand: 'ZAR',
      currencyGBP: 'British Pound',
      currencyNameGBP: 'GBP',
      currencySymbolRand: 'R',
      currencySymbolGBP: '£',
      amount: 'Amount',
      paymentRef: 'Use payment reference',
      accountType: 'Account type',
      bank: 'Bank',
      recipient: 'Recipient',
      sortCode: 'Sort Code',
      accountNumber: 'Account Number',
      branchNumber: 'Branch Code',
      swiftCode: 'SWIFT / BIC',
      IBAN: 'IBAN',
      quotedFee: 'Processing Fee',
      proofOfPaymentByCurrency: (
        fiatCurrencyCode: string,
        supportEmail: string | undefined,
      ) => {
        switch (fiatCurrencyCode) {
          case 'ZAR':
            return `Please note: Creating an <span style="font-weight:600">instant deposit</span> will result in a quicker deposit allocation.
                           <br />
                           Deposits <span style="font-weight:600">larger than R100 000.00</span> may take slightly longer to process. Please contact ${supportEmail} if your deposit takes longer than 24 hours to reflect.`;
          case 'EUR':
            return `Please make a payment using our IBAN. 
                            <br />
                            Please make sure you enter our business name.
                            <br />
                            Larger deposits may take a little longer to clear in our bank account.`;
          case 'GBP':
            return `Please make a payment using the payment reference provided. 
                                <br />
                                <br />
                                Larger deposits may take a little longer to clear in our bank account.`;
          default:
            return `Please make an international payment using our SWIFT / BIC code and account number. 
                            <br />
                            Please make sure you enter our business name.
                            <br />
                            Larger deposits may take a little longer to clear in our bank account.`;
        }
      },
      popSupport: `Or send your proof of payment to`,
      popUploadSuccess: 'You have successfully uploaded your proof of payment.',
      popUploadError: 'There was a problem uploading your proof of payment.',
      paymentMade: "I've made my payment",
      paymentLater: "I'll make the payment later",
      cancelPayment: 'Cancel payment',
      cancelPaymentError:
        "We couldn't cancel this payment. If we've already received your funds, it can't be cancelled.",
      fundsReceivedTitle: "We've received your deposit",
      fundsReceivedSubHeader:
        "We're processing it now. It'll show in your portfolio once it's done.",
      amountReceived: 'Amount received',
      fundsReceivedInfo: (supportEmail: string | undefined) =>
        `Larger deposits may take a little longer. If it hasn't reached your portfolio within 24 hours, contact us at ${supportEmail}.`,
      backToPortfolio: 'Back to portfolio',
      copyImg: 'Copy code',
      copied: 'Copied',
      companyAddress: 'Company Address',
      bankAddress: 'Bank Address',
    },
    bankTransferComplete: {
      imgAlt: 'deposit-complete',
      depositThanks: 'We’re on the lookout for your deposit',
      whatHappensNext: 'What happens next',
      nextStepList: `
                <ol class="custom-list">
                    <li class="custom-li">Your deposit will be allocated once it clears in our account.</li>
                    <li class="custom-li">You'll be notified via email when this happens.</li>
                    <li class="custom-li">You can then login to your account and make an investment.</li>
                </ol>
            `,
      exploreProducts: 'Explore products',
      setRecurringDeposit: 'Setup recurring deposit',
    },
    cryptoDeposit: {
      backText: '← Back',
      cryptoIconAlt: 'crypto-asset',
      typesHeading: 'Deposit crypto',
      typesSubHeading: 'Please select a cryptocurrency',
      price: 'Price',
      modalAlt: 'pending-deposit',
      modalHeadingCrypto: 'Pending deposit',
      modalContentCrypto:
        'You already have a deposit pending, if you would like to change your deposit please select cancel and create a new one.',
      modalProfileCrypto: 'Back to profile',
      modalCancelCrypto: 'Cancel deposit',
      assetNetworkHeading: 'Network',
      noResultsFound: 'No results found',
      searchAssets: 'Search assets',
    },
    cryptoDepositDetails: {
      backText: '← Back',
      modalImgAlt: 'please-note',
      modalHeading: 'Please note',
      modalContent: (supportEmail: string | undefined) => `
                <div class="flex justify-center text-center text-header-text text-lg font-semibold">
                    Please ensure that crypto deposits are sent to the correct native network.
                    <br/>
                    If you are unsure, please contact our support team before transacting.
                    <br />
                    <br />
                </div>

                <div className="flex justify-center text-center text-body-text text-base font-normal">
                    By depositing, you acknowledge that Altify is not responsible for any coins sent to the wrong address.
                    <br />
                    <br />
                    If you need assistance in making a deposit please reach out to ${supportEmail}.
                </div>
            `,
      modalAcknowledge: 'Yes, I acknowledge',
      modalCancel: "I'll need to come back later",
      typesHeading: 'Deposit',
      typesSubHeadingSection1: 'Please send your',
      typesSubHeadingSection2: ' to this address',
      copyText: 'Copy to clipboard',
      copiedText: 'Copied to clipboard',
      cryptoDisclaimer: `
                <div class="flex justify-start text-left text-body-text font-semibold text-sm">
                    Please ensure that you make your cryptocurrency deposit within 60min. If you plan to make your deposit later then please generate a new address to avoid delays.
                    <br />
                    <br />
                    Use the Copy to clipboard button to copy the crypto address to your wallet.
                    <br />
                    <br />
                    To reduce fraud and maximise security, we require 3 network confirmations in order to process deposits.
                    <br />
                    <br />
                </div>
            `,
      cryptoMin: 'Minimum:',
      cryptoMinTooltip:
        'Amounts deposited below this amount may not reflect in your account.',
      cryptoDepositFees: 'There are no crypto deposit fees.',
      cryptoDepositDepositMade: "I've made the deposit",
      bitcoinSymbol: 'BTC',
      modalAlt: 'crypto-deposit-error',
      errorModalContent:
        'Something went wrong, please return to your portfolio and try again',
      modalPortfolio: 'Back to portfolio',
      depositAddressToSendTo: `This is the address you'll be depositing to:`,
      walletAddress: 'Deposit Address',
      tag: 'Tag',
      minimumText: 'Minimum',
      feeText: 'Fee:',
      copyButtonText: 'Copy',
    },
    cryptoDepositDisclaimer: {
      disclaimerHeading: `Deposit`,
      disclaimerSubHeading: 'Instructions',
      networkHeading: 'Network',
      buttonCopy: 'I understand',
    },
    cryptoDepositFungibilityModal: {
      modalHeading: 'Please note',
      modalBodyP1: (
        fromProductCode: string,
        fromProductName: string,
        toProductCode: string,
        toProductName: string,
      ) =>
        `To improve your investing experience, we convert all ${fromProductName} (${fromProductCode}) deposits to ${toProductName} (${toProductCode}) at market rate.`,
      modalBodyP2: `There's no fee for this conversion.`,
      submitText: 'I understand',
      dontShowAgain: "Don't show me this again.",
    },
    cryptoDepositComplete: {
      imgAlt: 'deposit-complete',
      header: "We're looking out for your deposit",
      subText:
        "We'll send you an email letting you know once we receive your deposit.",
      exploreProducts: 'Explore products',
    },
    fundsWithdraw: {
      backText: '← Back',
      withdrawHeading: 'Withdraw funds',
      withdrawSubHeading: 'Select what you would like to withdraw',
      withdrawDetailsHeading: 'Withdrawal details',
      wallet: 'Wallet',
      balance: 'Available',
      accountCooldownTitle: '24h Withdrawal Suspension',
      accountCooldownContent: [
        'For you security, withdrawals have been temporarily paused due to recent changes to your personal details.',
        'You can request a new withdrawal after 24 hours.',
      ],
      imgAltNoFunds: 'no-funds',
      imgAltPendingWithdraw: 'pending-withdraw',
      modalHeading: {
        withdrawPending: 'Pending withdrawal',
        noWithdraw: 'No funds available',
      },
      modalContent: {
        withdrawPending: (
          pendingAmountString: string,
          availableAmountString: string,
        ) =>
          `You already have a withdrawal of ${pendingAmountString} pending, with ${availableAmountString} still available.`,
        noWithdraw:
          'You currently have no balances available to withdraw. Please visit your portfolio and sell a product to make a withdrawal.',
      },
      modalFooter: {
        cancelWithdrawalButton: 'Cancel withdrawal',
        closeButton: 'Close',
        goToProfile: 'Go to profile',
      },
      alt: 'withdraw-item',
      btc: 'BTC',
      reactOutAlt: 'react-out',
      reactOutHeading: 'Please reach out to us',
      reactOutContent: (
        supportEmail: string | undefined,
      ) => `We currently do not support the withdrawal of this currency, however, we can process your withdrawal in ZAR to a South African bank account registered in your name.
                <br/><br/> 
                To do this, please email us at <a class="text-header-text" href="mailto:${supportEmail}" target="_blank" rel="noopener noreferrer">${supportEmail}</a> and provide us with your banking details as well as the amount you would like to withdraw.
                <br/><br/> 
                If you don't have a South African bank account, or would prefer to make a Bitcoin withdrawal, all you need to do is purchase some Bitcoin and choose crypto as a withdrawal option.
                All we'll need then is your Bitcoin public key to process the payment.`,
      reactOutPortfolio: 'Back to portfolio',
      reserved: 'Reserved',
      reservedDescription:
        'Reserved funds are funds that are currently allocated to a withdrawal. To cancel a withdrawal click on the withdraw button.',
    },
    fundsWithdrawFiat: {
      backText: '← Back',
      withdrawHeading: 'Withdraw',
      withdrawSubHeading: 'Please specify the amount',
      currencySymbolRand: 'R',
      currencySymbolGBP: '£',
      leftText: 'Fee',
      leftTooltip: 'Our withdrawal fee covers all  processing charges.',
      rightText: 'Minimum',
      rightTooltipSection1: 'This is the minimum amount that can be withdrawn.',
      rightTooltipSection2: 'and the withdrawal fee',
      extraText: `
                <div class="flex justify-center font-semibold text-header-text mb-4 text-sm text-center">
                    Withdrawals are processed once a day at 15:30 SAST on weekdays, excluding weekends and public holidays.
                </div>
            `,
      next: 'Next',
      modalBankAccountHeader: 'Add Banking Details',
      modalBankAccountButton: 'Continue',
      imgAlt: 'no-bank-account',
      blockedNavigation:
        'Your withdrawal request is currently being created, please wait for it to complete.',
    },
    fundsBankDetails: {
      backText: '← Back',
      detailsHeading: 'Bank Details',
      detailsHeadingSubHeading: 'Please enter your bank details below',
      bankCountry: 'Bank Account Country',
      bankAccountNumber: 'Account Number',
      bankName: 'Bank Name',
      bankAccountType: 'Account Type',
      bankBranch: 'Branch Code',
      bankSortCode: 'Sort Code',
      bankIBAN: 'IBAN (Optional)',
      bankIBANOrSwift: 'SWIFT / BIC',
      bankExtraText:
        'This account must be registered in your own name. Withdrawals to 3rd party accounts cannot  be processed.',
      bankBlockParagraph:
        'A 24 hour cooling off period applies to withdrawals after creating or updating your bank details.',
    },
    fundsWithdrawFiatReview: {
      backText: '← Back',
      withdrawHeading: 'Withdraw',
      reviewSubHeading: `Please confirm your account details. <br />Note that <span class="text-header-text">we do not allow</span> withdrawals to third parties.`,
      pendingRecipient: 'Recipient',
      pendingAccountNumber: 'Account Number',
      pendingType: 'Type',
      pendingBank: 'Bank',
      pendingBranchCode: 'Branch Code',
      pendingSortCode: 'Sort Code',
      pendingIBAN: 'IBAN',
      pendingIBANOrSwift: 'SWIFT / BIC',
      pendingEditBankDetails: 'Edit bank details',
      pendingEditBankDetailsAlt: 'edit-icon',
      pendingSeeMore: 'See more',
      pendingSeeLess: 'See less',
      pendingExtraTextShort:
        'We process all withdrawals within 24 hours. Depending on your bank and the size of the withdrawal a transfer can take up to 5 business days to arrive in your account.',
      pendingExtraTextSection1ZAR: `
            We process all withdrawals within 24 hours. Depending on your bank and the size of the withdrawal a transfer can take up to 5 business days to arrive in your account.
            <br />
            <br />
            We charge a R10 withdrawal fee. There is a minimum withdrawal amount of R100. For more info see our
            `,
      pendingExtraTextSection1INT: (currencySymbol: string) => `
                We process all withdrawals within 24 hours. Depending on your bank and the size of the withdrawal a transfer can take up to 5 business days to arrive in your account.
                <br />
                <br />
                We charge a 1.00% withdrawal processing fee with a minimum fee of ${currencySymbol}30.00 and a maximum of ${currencySymbol}60.00. For more info, visit our
            `,
      pendingFeeText: 'fees page.',
      pendingExtraTextSection2: `
                <br />
                <br />
                Customers who elect to close their account will receive a one-time exemption from the withdrawal minimums for their final withdrawals.
                <br />
                <br />
                The account that you are withdrawing to must be registered in your own name. Withdrawals to 3rd party accounts cannot be processed.`,
      pendingUnderstand: 'I understand and accept all outlined above.',
      pendingNext: 'Next',
      modalPortfolioCrypto: 'Back to portfolio',
      modalAlt: 'non-2fa-withdraw',
      pendingHeader: 'Check your email',
      pending1: 'We have sent you a confirmation email to',
      pending2:
        'please click the confirm button within the email to authorise this withdrawal.',
    },
    fundsFiatInProgress: {
      backText: '← Back',
      withdrawHeading: 'Withdraw',
      inProgressSubHeading:
        'We will send you an email as soon as your withdrawal has been processed.',
      // currencyNameRand: '',
      // currencyNameGBP: '',
      // currencyRand: '',
      // currencyGBP: '',
      // currencySymbolRand: '',
      // currencySymbolGBP: '',
      amount: 'Amount',
      reference: 'Reference',
      date: 'Date',
      timeZAR: 'Time (GMT)',
      timeGBP: 'Time (GMT)',
      recipient: 'Recipient',
      accountNumber: 'Account Number',
      type: 'Type',
      bank: 'Bank',
      branchCode: 'Branch Code',
      sortCode: 'Sort Code',
      IBAN: 'IBAN',
      withdrawalAmount: 'Amount Before Fee',
      fee: 'Bank Withdrawal Fee',
      amountReceived: 'Amount After Fee',
      portFolio: 'Back to portfolio',
      alt: 'country-flag',
    },
    fundsCryptoDetails: {
      backText: '← Back',
      heading: 'Withdraw',
      subHeadingSection: ' will be withdrawn to your saved address below',
      add: 'Add',
      edit1: 'Edit',
      edit2: ' address',
      extraText1: `
                Please only withdraw bitcoins to your own wallet. If you need to use your bitcoin balance for a payment, please first withdraw them from your Altify account to your own wallet.
                <br />
                <br />
                Please note that withdrawals are sent to the address registered at the time of placing the withdrawal request and it is not possible to cancel a withdrawal or change the destination address for a withdrawal after placing the request.
            `,
      extraTextUsdt: `
                Please only withdraw Tether to your own wallet. If you need to use your Tether balance for a payment, please first withdraw them from your Altify account to your own wallet.
                <br />
                <br />
                Please note that withdrawals are sent to the address registered at the time of placing the withdrawal request and it is not possible to cancel a withdrawal or change the destination address for a withdrawal after placing the request.
            `,
      extraText2:
        'By withdrawing, I acknowledge that Altify is not responsible for any coins sent to the wrong address.',
      acknowledge: 'Yes, I acknowledge',
      continue: 'Continue',
      noAddress: `You don't have any addresses`,
      noRef: 'No reference available',
    },
    fundsCryptoAmount: {
      backText: '← Back',
      heading: 'Withdraw',
      subHeadingSection1: 'Please enter the',
      subHeadingSection2: ' amount',
      alt: 'crypto-icon',
      selectAmount: 'Select amount',
      fee: 'Fee',
      minText: 'Minimum',
      leftTooltip1: 'There is a nominal charge of',
      leftTooltip2: ' for bitcoin withdrawals to cover miner fees.',
      leftFeeTooltip: (productName: string, feeAsCurrency: string) =>
        `There is a nominal charge of ${feeAsCurrency} for ${productName} withdrawals to cover miner fees.`,
      rightFeeTooltip: (feeAsCurrency: string) =>
        `'The minimum withdrawal amount must be more than the minimum fee of ${feeAsCurrency}`,
      rightTooltip:
        'The minimum withdrawal amount must be more than the minimum fee of 0.0005 bitcoins.',
      withDrawTo1: 'Withdraw to',
      withDrawTo2: ' address',
      extraText1:
        " withdrawals are manually reviewed for enhanced security. They're processed on business days only, not on weekends or public holidays.",
      continue: 'Continue',
      modalPortfolioCrypto: 'Back to portfolio',
      modalAlt: 'non-2fa-withdraw',
      pendingHeader: 'Check your email',
      pending1: 'We have sent you a confirmation email to',
      pending2:
        'please click on the confirmation link to complete your withdrawal.',
      btc: 'BTC',
      blockedNavigation:
        'Your withdrawal request is currently being created, please wait for it to complete.',
    },
    fundsCryptoComplete: {
      imgAlt: 'withdraw-complete',
      heading: "We've received your withdrawal request",
      subHeading: `
                Your withdraw will be processed within the next <span class="text-header-text"><span style="font-weight:600" >24 hours</span></span>.
            `,
      button: 'Back to portfolio',
    },
    fundsPending: {
      error: 'Token is no longer valid',
      modalAlt: 'token-not-valid',
      modalPortfolioCrypto: 'Back to portfolio',
    },
    transactions: {
      goToTransactions: 'Transaction History',
    },
    linkedAccounts: {
      linkedAccountsHeading: 'Linked accounts',
      linkedAccountsSubHeading: 'Link your bank account with Stitch',
      linkedAccountText:
        'Altify uses Stitch to connect to your bank account for fast, affordable and secure deposits.',
      maximumAmount: 'Maximum amount',
      feeText: 'Fee',
      buttonCopy: 'Link with Stitch',
      allocationTime: 'Allocation time',
      secureText: 'Your data is stored securely',
      maximumAmountValue: 'R100 000',
      feeAmount: '1.00%',
      allocationTimeResult: 'Instant',
      availableText: 'Available:',
      customerBank: 'Bank',
      accountType: 'Account type',
      accountNumber: 'Account number',
      availableBalance: 'Account balance',
      manageAccountSubHeading: 'Manage your account',
      renameButtonCopy: 'Rename',
      unlinkButtonCopy: 'Unlink',
      accountDetails: 'Account Details',
      unlinkAccountModalCopy: 'Are you sure you want to unlink this account?',
      unlinkAccountModalRemoveText: (accountName: string) =>
        `This will remove ${accountName} from your Altify profile.`,
      unlinkAccountModalButtonCancelText: 'Cancel',
      unlinkAccountModalButtonUnlinkText: 'Yes, Unlink',
    },
    depositAccountName: {
      subHeading: 'Update your account name',
      chooseNameText:
        'Choose a friendly name that makes it easy for you to recognise which account you’re using.',
      accountName: 'Account name',
      buttonCopy: 'Save changes',
      accountNameModalHeading: 'Account link successful',
      accountNameModalText:
        'You can now use this account for instant deposits into your Altify account!',
      accountNameModalButtonCopy: 'Continue',
      renameAccountLater: 'Rename your account later',
      renameAccountLaterText:
        'If you cancel now, you can update the name of this account later from the Linked accounts section in your profile.',
      defaultAccountNameText: (accountName: string) =>
        `We’ll name this account ${accountName} for now.`,
      renameAccountLaterButtonCopy: 'Continue',
      unlinkAccountModalHeading: 'Account unlink successful',
      unlinkAccountModalText: (accountName: string) =>
        `${accountName} was successfully unlinked from your Altify profile.`,
      renameLinkedAccountSuccessfulHeading: 'Account rename successful',
    },
  },
};

export default messages;
